import { Checkbox } from "@mui/material";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import type React from "react";

import { type TestId, TestIds } from "@storyboard/web-test-ids/testIds";
import { zinc } from "./tokens";

export default function FilterListItem({
  checked,
  onClick,
  label,
  startAdornment,
  active,
  showCheckbox = true,
  icon,
  disabled = false,
  testId = TestIds.driverView.filterOption,
}: {
  checked: boolean;
  onClick: () => void;
  label: string;
  startAdornment?: React.ReactNode;
  active: boolean;
  showCheckbox?: boolean;
  icon?: React.ReactNode;
  disabled?: boolean;
  /** Browser-test id; sort choices register separately from filter values so tests can tell them apart. */
  testId?: TestId;
}) {
  return (
    <Box component="li" sx={{ "&:not(:last-child)": { mb: 0.5 }, display: "flex", alignItems: "center", gap: 1 }}>
      <ButtonBase
        data-sb={testId}
        disabled={disabled}
        onClick={onClick}
        sx={{
          width: "100%",
          px: 1,
          py: 0.25,
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          borderRadius: 1,
          justifyContent: "flex-start",
          color: active ? "white" : zinc[400],
          bgcolor: active ? zinc[700] : "transparent",
          "&:hover": { bgcolor: disabled ? "transparent" : zinc[700] },
          "&.Mui-disabled": { opacity: 0.4 },
          fontSize: "0.875rem",
        }}
      >
        {showCheckbox && <Checkbox sx={{ p: 0 }} checked={checked} />}
        {icon}
        {startAdornment}
        <Box>{label}</Box>
      </ButtonBase>
    </Box>
  );
}
